<template>
  <!-- 详细信息 -->
  <div class='pullPage'>
    <Tabs :tabs='detailTbs' :activeCom.sync='Dactive' />
    <div class='detailClass'>
      <BaseList @saveDecFn='confrimFn' :baseMsgArray='baseMsgArray' :detailObj='detailObj' :isMode.sync='isMode'
                @modeChanges='modeChanges' />
      <Upload :Upload='Upload' :isMode='isMode' ref='upload' />
      <changeIcon :isMode='isMode' @modeChange='modeChange' />
    </div>
    <Tabs :tabs='tabsArray' :activeCom.sync='tabsActive' />
    <!-- <NetParam :detailNetObj="netArray" /> -->
    <keep-alive>
      <component :is='tabsActive' v-bind='$attrs' :detailNetObj='netArray' />
    </keep-alive>
    <div class='bottom_btn'>
      <el-button type='primary' v-if='detailObj.isHeart === 1' @click='hearFn'>{{ $t('device.heartbeat_history') }}
      </el-button>
      <el-button type='primary' @click='closeFn'>{{ $t('buttonTitle.Close') }}</el-button>
    </div>
    <!-- 心跳弹窗 -->
    <HearDialog :append-to-body='true' :totalAll='totalAll' :title='hearTitle' :isShow.sync='isShow'
                :tableData='tableData' :mac='hearQuery.mac' />
  </div>
</template>

<script>
import Tabs from '@/pages/equipment/publicCom/Tabs.vue'
import NetParam from '@/pages/equipment/publicCom/NetParam.vue'
import Application from '@/pages/equipment/publicCom/Application.vue'
import changeIcon from '@/pages/equipment/publicCom/changeIcon.vue'
import Upload from '@/pages/equipment/publicCom/Upload.vue'
import BaseList from './component/BaseList.vue'
import HearDialog from './component/hearDialog.vue'
import { gatewayhistoryList, gatewayUpdate } from '@/api/modules/gateway.js'
import resultHandle from '@/common/resultHandle'

export default {
  props: ['netObj', 'detailObj'],
  components: {
    Tabs,
    Upload,
    BaseList,
    changeIcon,
    NetParam,
    Application,
    HearDialog
  },
  watch: {
    netObj (newVal) {
      this.netArray.forEach(item => {
        item.content = newVal[item.key]
      })
      this.isMode = false
    },
    detailObj (newVal) {
      this.isMode = false
      this.Upload = {
        imageUrl: { ...newVal }.pictureBase64,
        // 图片后缀
        imageSuffix: { ...newVal }.pictureSuffix
      }
    }
  },
  data () {
    return {
      detailTbs: [
        {
          name: 'Detail',
          label: 'public.detail_info'
        }
      ],
      Dactive: 'Detail',
      tabsArray: [
        {
          name: 'Application',
          label: 'public.attribute'
        },
        {
          name: 'NetParam',
          label: 'public.net_param'
        }
      ],
      tabsActive: 'Application',

      baseMsgArray: [
        {
          key: 'url',
          text: 'public.belong'
        },
        {
          key: 'name',
          text: $t('integration.gateway_name_')
        },
        {
          key: 'nickname',
          text: $t('integration.gateway_nickname')
        },
        {
          key: 'carrierName',
          text: $t('integration.mount_')
        },
        {
          key: 'mac',
          text: 'device.gateway_mac'
        },
        {
          key: 'sn',
          text: 'device.gateway_serial_num'
        },
        {
          key: 'code',
          text: 'device.gateway_type'
        },
        {
          key: 'status',
          text: 'device.gateway_status'
        },
        {
          key: 'edited',
          text: 'device.activated'
        },
        {
          key: 'configStatus',
          text: 'device.config_status'
        },
        {
          key: 'createTime',
          text: 'public.table_create_time'
        },
        {
          key: 'powerStatus',
          text: $t('integration.battery_supply')
        },
        // {
        //     key: 'long_addr',
        //     text: 'device.long_addr'
        // },
        // {
        //     key: 'short_addr',
        //     text: 'device.short_addr'
        // },

        // {
        //     key: 'channelMask',
        //     text: 'device.channel_mask'
        // },

        // {
        //     key: 'tcp_status',
        //     text: $t('integration.tcp_connection')
        // },
        // {
        //     key: 'lte_status',
        //     text: $t('integration.let_connection_status')
        // },
        // {
        //     key: 'flight_mode',
        //     text: $t('integration.flight_mode')
        // },
        // {
        //     key: 'self_ip',
        //     text: $t('integration.self_ip_attribute')
        // },
        {
          key: 'isHeart',
          text: 'device.heartbeat_on'
        },
        {
          key: 'description',
          text: $t('public.table_desc')
        }
      ],
      netArray: [
        {
          key: 'extPanId',
          text: 'extPanId',
          content: ''
        },
        {
          key: 'channelPage',
          text: 'channelPage',
          content: ''
        },
        {
          key: 'channelMask',
          text: 'device.channel_mask',
          content: ''
        }
      ],
      isMode: false,
      // 图片
      Upload: {},
      // 心跳
      hearTitle: '',
      isShow: false,
      hearQuery: {
        iDisplayStart: 0,
        iDisplayLength: 15,
        mac: null,
        startTime: null,
        endTime: null
      },
      tableData: [],
      totalAll: 0
    }
  },
  mounted () {
    if (this.$attrs.sensorWay === 'unknown') {
      this.baseMsgArray = this.baseMsgArray.filter(item => item.key !== 'carrierName' && item.key !== 'configStatus')
    }
    if (this.$attrs.sensorWay === 'unbind') {
      this.baseMsgArray = this.baseMsgArray.filter(item => item.key !== 'carrierName')
    }
    if (this.$attrs.sensorWay === 'stop') {
      this.baseMsgArray = this.baseMsgArray.filter(item => item.key !== 'configStatus')
    }
  },
  methods: {
    closeFn () {
      window.close()
    },
    modeChange () {
      this.isMode = !this.isMode
    },
    modeChanges (row) {
      this.isMode = !this.isMode
      this.$parent.detailFn(row)
    },
    confrimFn (row) {
      const {
        imageSuffix,
        imageUrl
      } = this.$refs.upload.newUpload
      const {
        id,
        is_heart,
        nickname,
        areaValue
      } = row
      gatewayUpdate({
        id,
        is_heart,
        nickname,
        description: areaValue,
        uploadFileBase64: imageUrl,
        uploadFileSuffix: imageSuffix
      }).then(async ({ state }) => {
        await resultHandle(state)
        this.isMode = !this.isMode
        this.$emit('changdetail', this.detailObj)
        // this.$parent.getListFn()
      })
    },
    hearFn () {
      this.isShow = true
      this.hearTitle = `[${this.detailObj.name}]` + $t('integration.gateway_heartbeat_history')
      this.hearQuery.mac = this.detailObj.mac
      gatewayhistoryList(this.hearQuery).then(({ result }) => {
        this.tableData = result.result
        this.totalAll = result.pageInfo.total
      })
    }
  }
}
</script>

<style lang='scss' scoped>
.pullPage {
  height: 100%;
  width: 100%;
  padding: 0 15px;
  box-sizing: border-box;

  .bottom_btn {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 50px;
    border-top: 1px solid #e7e7e7;
    line-height: 50px;
    text-align: center;

    button {
      margin: 0 10px;
    }
  }
}

.detailClass {
  display: flex;
}
</style>
